<template>
  <div class="claims-list">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ClaimsList',
});
</script>

<style lang="scss"></style>
